module.exports = __webpack_public_path__ + "img/history_btn.166ac1ec.png";